import styled from 'styled-components'

const Style = {
	Container: styled.div`
		display: flex;
		flex-direction: column;
		gap: 8px;
	`,
	Label: styled.p`
		width: 100%;
		${({theme}) => theme.font.small};
		text-align: center;
		padding: 8px 0;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			padding: 0;
		}
	`,
	BtnDiv: styled.div`
		display: flex;
		gap: 8px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			gap: 23px;
		}
	`,
	Title: styled.p`
		width: 100%;
		${({theme}) => theme.font.small};
		text-align: center;
		padding: 8px 0;
		font-weight: bold;
		color: ${({theme}) => theme.color.primary};
	`,
}

export default Style
